import {functionSupportConst} from '../constants/actionConstants'
import {objPendingErrorFalse} from '../constants/variableConstant'

const initState = {
  resFuncSupport:{},
  pending: false,
  error: false
}

export default (state = initState, action) => {
  switch (action.type) {
    case functionSupportConst.GET_DATA_FUNCTION_SUPPORT_SUCCESS:
      return {
        ...state,
        ...objPendingErrorFalse,
        resFuncSupport: action.payload
      }
    case functionSupportConst.FUNCTION_SUPPORT_PENDING:
      return {
        ...state,
        pending: action.payload
      }
    case functionSupportConst.FUNCTION_SUPPORT_ERROR:
      return {
        ...initState,
        error: action.payload
      }
    case functionSupportConst.FUNCTION_SUPPORT_RESET_STATE:
      return initState
    default:
      return state
  }
}
